import React, { useEffect, useRef } from 'react';

// Travelpayouts widgets are a single <script> that renders itself next to the
// tag. React won't execute scripts rendered as JSX, so inject it on mount.
export function TravelpayoutsWidget({ src, className = '', dataTestId }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !src) return;
    container.innerHTML = '';
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.charset = 'utf-8';
    container.appendChild(script);
    return () => { container.innerHTML = ''; };
  }, [src]);

  if (!src) return null;
  return <div ref={containerRef} className={className} data-testid={dataTestId} />;
}
